import React from 'react';
import PropTypes from 'prop-types';
import { VegaModal, VegaFlex, VegaBox, VegaButton } from '@heartlandone/vega-react';

/**
 * DeleteRegisterModal - confirmation modal styled like CancelActivityConfirm using slot API.
 */
function DeleteRegisterModal({ open, register, onConfirm, onClose }) {
  // Three-line content with explicit line breaks.
  const content1 = `Are you sure you want to remove the participant?`;
  const content2 = `An email will be sent to the participant. Related guest(s) will be removed as well.`;

  return (
    <VegaModal
      size={480}
      backdrop="static"
      open={open}
      type="danger"
      onVegaClose={() => onClose && onClose()}
    >
      <div slot="modal-title">
        <div>Remove Participant</div>
      </div>
      <div slot="modal-content">
        <VegaFlex direction={'col'} gap={'size-20'}>
          <VegaBox className="f-weight-500">
            {content1}
          </VegaBox>
          <VegaBox className="f-weight-500">
            {content2}
          </VegaBox>
        </VegaFlex>
      </div>
      <div slot="modal-footer">
        <VegaFlex direction="row" gap="size-12" justifyContent="end">
          <VegaButton
            danger
            label="Cancel"
            variant="secondary"
            size="small"
            onVegaClick={() => onClose && onClose()}
          />
          <VegaButton
            danger
            label="Remove"
            size="small"
            onVegaClick={() => {
              if (onConfirm) onConfirm(register);
              if (onClose) onClose();
            }}
          />
        </VegaFlex>
      </div>
    </VegaModal>
  );
}

DeleteRegisterModal.propTypes = {
  open: PropTypes.bool,
  register: PropTypes.object,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
};

export default DeleteRegisterModal;
